import MessageListItem from './message-list-item.vue'
export default MessageListItem